import { MegaphoneIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { useEffect, useState } from "react";

export default function Alert({
  id,
  status,
  message,
  timeout,
}: {
  id: string;
  status: string;
  message: string;
  timeout: number;
}) {
  const [show, setShow] = useState(true);

  function getBgColour() {
    if (status === "danger") return "danger";
    if (status === "success") return "success";
    if (status === "warning") return "warning";
    return "white";
  }

  function getTextColour() {
    if (status === "danger") return "white";
    if (status === "success") return "white";
    if (status === "warning") return "black";
    return "black";
  }

  useEffect(() => {
    const timeId = setTimeout(() => {
      // After 3 seconds set the show value to false
      setShow(false);
    }, timeout);

    return () => {
      clearTimeout(timeId);
    };
  }, [timeout]);

  if (!show) {
    return null;
  }

  return (
    <div className="fixed inset-x-0 bottom-0 pb-2 sm:pb-5 z-[100]" key={id}>
      <div className="mx-auto max-w-7xl px-2 sm:px-6 lg:px-8">
        <div className={`bg-${getBgColour()} rounded-lg p-2 shadow-lg sm:p-`}>
          <div className="flex flex-wrap items-center justify-between">
            <div className="flex w-0 flex-1 items-center">
              <span className="flex rounded-lg bg-transparent p-2">
                <MegaphoneIcon
                  className={`h-6 w-6 text-${getTextColour()}`}
                  aria-hidden="true"
                />
              </span>
              <p
                className={`ml-3 truncate font-medium text-${getTextColour()}`}
              >
                <span className="md:hidden">{message}</span>
                <span className="hidden md:inline">{message}</span>
              </p>
            </div>
            <div className="order-2 flex-shrink-0 sm:order-3 sm:ml-2">
              <button
                type="button"
                className={`-mr-1 flex rounded-md p-2 hover:bg-slate-100/10 focus:outline-none focus:ring-2 focus:ring-${getTextColour()}`}
              >
                <span className="sr-only">Dismiss</span>
                <XMarkIcon
                  className={`h-6 w-6 text-${getTextColour()}`}
                  aria-hidden="true"
                />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}